import React from 'react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-400 py-12 text-sm" data-id="element-64">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center" data-id="element-65">
        <div className="mb-6 max-w-2xl" data-id="element-66">
          <p className="mb-4" data-id="element-67">
            El contenido de esta página tiene fines educativos e informativos.
            No reemplaza diagnóstico, tratamiento ni acompañamiento profesional.
          </p>
          <p data-id="element-68">© 2026 Sistema 360 Lash — Todos los derechos reservados.</p>
        </div>

        <div className="flex flex-wrap justify-center gap-6" data-id="element-69">
          <a href="#" className="hover:text-white transition-colors" data-id="element-70">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-71">
            Política de Privacidad
          </a>
          <a href="mailto:tera.ventasonline@gmail.com" className="hover:text-white transition-colors" data-id="element-72">
            Contacto
          </a>
        </div>
      </div>
    </footer>;
}